

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(app)/_layout.svelte.js')).default;
export const imports = ["_app/immutable/nodes/2.D9sOkrJi.js","_app/immutable/chunks/CWj6FrbW.js","_app/immutable/chunks/CvggxNKg.js","_app/immutable/chunks/DXxkZ4MO.js","_app/immutable/chunks/a9k1QIbI.js","_app/immutable/chunks/aFTmJgMS.js","_app/immutable/chunks/BgXaETc1.js","_app/immutable/chunks/Cc9MKd4K.js"];
export const stylesheets = [];
export const fonts = [];
